class WorkPlanParametrizationSrv {

  constructor ($resource, SERVICE_URL_CONSTANT) {
  // PARAMETRIZATION LIST SERVICE
    var getWorkPlans = $resource(SERVICE_URL_CONSTANT.rosario + '/workplan', {}, {
      get: {
        method: 'GET' 
      }
    })

    var getWorkPlan = $resource(SERVICE_URL_CONSTANT.rosario + '/workplan/:id', {}, {
      get: {
        method: 'GET'
      }
    })

    var getPeriodicity = $resource(SERVICE_URL_CONSTANT.rosario + '/periodicity', {}, {
      get: {
        method: 'GET'
      }
    })

    var getStage = $resource(SERVICE_URL_CONSTANT.rosario + '/stage', {}, {
      get: {
        method: 'GET'
      }
    })

    var hoursOfDedicated = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/getTeacherWorkplan/:workplanId', {}, {
      get: {
        method: 'GET'
      }
    })

    var addWorkplan = $resource(SERVICE_URL_CONSTANT.rosario + '/workplan/saveAllDataWorkPlan', {}, {
      add: {
        method: 'POST'
      }
    })

    var addWorkplanHoursOfDedicated = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/addHoursTeacherWorkplan', {}, {
      add: {
        method: 'POST'
      }
    })

    var addTeacherEvaluator = $resource(SERVICE_URL_CONSTANT.rosario + '/reviewer/addTeacherEvaluator', {}, {
      add: {
        method: 'POST'
      }
    })

    var getWorkPlanHeader = $resource(SERVICE_URL_CONSTANT.rosario + '/workplan/header/:workplanId', {}, {
      get: {
        method: 'GET'
      }
    })

    var getAssignmentOfEvaluator = $resource(SERVICE_URL_CONSTANT.rosario + '/reviewer/getListTeacherEvaluator', {}, {
      get: {
        method: 'POST'
      }
    })

    var getTeacherEvaluator = $resource(SERVICE_URL_CONSTANT.rosario + '/reviewer/getTeacherEvaluator/:idTeacher', {}, {
      get: {
        method: 'GET'
      }
    })

    var getUsers = $resource(SERVICE_URL_CONSTANT.rosario + '/reviewer/getUsers', {}, {
      get: {
        method: 'GET'
      }
    })

    var getRoles = $resource(SERVICE_URL_CONSTANT.rosario + '/reviewer/getRole', {}, {
      get: {
        method: 'GET'
      }
    })
    

   var disableTeacherEvaluator = $resource(SERVICE_URL_CONSTANT.rosario + '/reviewer/disableTeacherEvaluator', {}, {
      set: {
        method: 'POST'
      }
    })

    var getTeacherSubmodules = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/submodules', {}, {
      get: {
        method: 'GET'
      }
    })

    var getTeacherCategories = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/categories', {}, {
      get: {
        method: 'GET'
      }
    })

    var addTeacherSubmodules = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/addRelationTeacherSubmodule', {}, {
      add: {
        method: 'POST'
      }
    })

  // WORKPLAN ACTIVITIES SERVICES
    var getRelationTeacherSubmodules = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/getRelationTeacherSubmodule/:workplanId', {}, {
      get: {
        method: 'GET'
      }
    })

  // SPECIAL SITUATION SERVICES
    var getSpecialSituationData = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/getSpecialSituationData', {}, {
      get: {
        method: 'POST'
      }
    })

    var getTeachersDetails = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/getTeachersDetails/:idTeacher/:idWorkplan', {}, {
      get: {
        method: 'GET'
      }
    })

    var addSpecialSituationTeacher = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/addSpecialSituationTeacher', {}, {
      set: {
        method: 'POST'
      }
    })

  // CRITERIA LIST SERVICES
    var criteriaListService = $resource(SERVICE_URL_CONSTANT.rosario + '/criteria/getCriteriaWorkplanCategory', {}, {
      get: {
        method: 'GET'
      }
    })

    var criteriaItemService = $resource(SERVICE_URL_CONSTANT.rosario + '/criteria/getsItems/:categoryId', {}, {
      get: {
        method: 'GET'
      }
    })

    var createCriterias = $resource(SERVICE_URL_CONSTANT.rosario + '/criteria/addCriteria', {}, {
      create: {
        method: 'POST'
      }
    })

    var associatePlanToCriterias = $resource(SERVICE_URL_CONSTANT.rosario + '/criteria/associateCriteria', {}, {
      associate: {
        method: 'POST'
      }
    })

    var deleteCriteriaListItem = $resource(SERVICE_URL_CONSTANT.rosario + '/criteria/deleteCriteria', {}, {
      delete: {
        method: 'POST'
      }
    })

    var workplanListAssociation = $resource(SERVICE_URL_CONSTANT.rosario + '/criteria/getWorkplanCriteriaAll', {}, {
      get: {
        method: 'GET'
      }
    })

    var disassociateCriteria = $resource(SERVICE_URL_CONSTANT.rosario + '/criteria/disassociateCriteria', {}, {
      disassociate: {
        method: 'POST'
      }
    })

    var workplanByCategory = $resource(SERVICE_URL_CONSTANT.rosario + '/workplan/getWorkplanByCategory/:categoryId', {}, {
      get: {
        method: 'GET'
      }
    })

  // WORKPLAN ACTIVATION SERVICES

    var getTeacherStateList = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/getTeacherStateList', {}, {
      get: {
        method: 'POST'
      }
    })

    var getTeacherSubmoduleList = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/getListWpSubmoduleTeacherActivate/:idTeacher', {}, {
      get: {
        method: 'GET'
      }
    })

  // OTHER SERVICES
    var updateCriteria = $resource(SERVICE_URL_CONSTANT.rosario + '/criteria/updateCriteria', {}, {
      update: {
        method: 'POST'
      }
    })

    var cloneWorkPlan = $resource(SERVICE_URL_CONSTANT.rosario + '/workplan/cloneWorkPlan', {}, {
      add: {
        method: 'POST'
      }
    })

    var activateWpSubmoduleTeacher = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/setActivateWpSubmoduleTeacher', {}, {
      set: {
        method: 'POST'
      }
    })

    var getTeacherSubmodulesWithDoWorkplan = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/getSubmodulesWithWorkplan', {}, {
      get: {
        method: 'GET'
      }
    })    

    var getAllActivities = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/getAllActivities/:workplanId', {}, {
      get: {
        method: 'GET'
      }
    })

    var getTeachertypeModules = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/getTeachertypeModules', {}, {
      get: {
        method: 'GET'
      }
    })

    var addRelationTeachertypeModules = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/addRelationTeachertypeModules', {}, {
      add: {
        method: 'POST'
      }
    })


  // SERVICES DEFINITIONS
    return {
      getWorkPlans: getWorkPlans,
      getWorkPlan: getWorkPlan,
      hoursOfDedicated: hoursOfDedicated,
      getPeriodicity: getPeriodicity,
      getStage: getStage,
      addWorkplan: addWorkplan,
      addWorkplanHoursOfDedicated: addWorkplanHoursOfDedicated,
      getWorkPlanHeader: getWorkPlanHeader,
      getTeacherSubmodules: getTeacherSubmodules,
      getTeacherCategories: getTeacherCategories,
      addTeacherSubmodules: addTeacherSubmodules,
      getRelationTeacherSubmodules: getRelationTeacherSubmodules,
      criteriaListService: criteriaListService,
      criteriaItemService: criteriaItemService,
      deleteCriteriaListItem: deleteCriteriaListItem,
      associatePlanToCriterias: associatePlanToCriterias,
      createCriterias: createCriterias,
      workplanByCategory: workplanByCategory,
      workplanListAssociation: workplanListAssociation,
      getAssignmentOfEvaluator: getAssignmentOfEvaluator,
      disassociateCriteria: disassociateCriteria,
      updateCriteria: updateCriteria,
      getTeacherSubmodulesWithDoWorkplan: getTeacherSubmodulesWithDoWorkplan,
      getAllActivities: getAllActivities,
    // WORKPLAN ACTIVATION SERVICES
      getTeacherStateList: getTeacherStateList,
      getUsers: getUsers,
      cloneWorkPlan: cloneWorkPlan,
      getRoles: getRoles,
      getTeacherEvaluator: getTeacherEvaluator,
      getTeacherSubmoduleList: getTeacherSubmoduleList,
    // SPECIAL SITUATION SERVICES
      getSpecialSituationData: getSpecialSituationData,
      getTeachersDetails: getTeachersDetails,
      addSpecialSituationTeacher: addSpecialSituationTeacher,
      addTeacherEvaluator: addTeacherEvaluator,
      activateWpSubmoduleTeacher: activateWpSubmoduleTeacher,
      disableTeacherEvaluator:disableTeacherEvaluator,
      getTeachertypeModules: getTeachertypeModules,
      addRelationTeachertypeModules: addRelationTeachertypeModules
    }
  }
}

WorkPlanParametrizationSrv.$inject = ['$resource', 'SERVICE_URL_CONSTANT']
export default angular.module('services.WorkPlanParametrizationSrv', []).service('WorkPlanParametrizationSrv', WorkPlanParametrizationSrv).name



// WEBPACK FOOTER //
// ./src/app/u-faculty/workPlanParametrization/workPlanParametrizationSrv.js